import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Form, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModuleBreakType, WMRPModule, WmrpAnalysisParam, WmrpAnalysisRun, WmrpCondition, WmrpSaveObject, lookupDictionary } from 'src/app/state-management';

@Component({
    selector: 'app-wmrp-conditions',
    templateUrl: './wmrp-conditions.component.html',
    styleUrls: ['./wmrp-conditions.component.scss'],
    standalone: false
})
export class WmrpConditionsComponent implements OnInit, OnChanges {
  @ViewChild('condition') condition: NgbModalRef;

  @Input() wmrpMod: WMRPModule[];
  @Input() materials: lookupDictionary[];
  @Input() panelHeight: number;
  @Input() currentConditions: any;
  @Input() editable: boolean;
  @Input() checkCount: number;
  @Input() recentAnalyses: WmrpAnalysisRun[];
  @Input() isWMRPUser: boolean;

  @Output() countEmitter = new EventEmitter<number>();
  @Output() paramsSaveEmitter = new EventEmitter<WmrpSaveObject>();
  @Output() runAnalysisCustomEmitter = new EventEmitter<WmrpAnalysisParam[]>();
  @Output() runAnalysisTemplateEmitter = new EventEmitter<number>();
  @Output() exportEmitter = new EventEmitter<null>();

  conditionsForm: UntypedFormGroup;
  inputForm: UntypedFormGroup;
  templateForm: UntypedFormGroup;
  modal: NgbModalRef = null;
  currentParameterIndex = -1;
  currentConditionIndex = -1;
  breakType: any;
  conditionsHeight: number;
  // checkCount = 0;
  showTemplateForm = true;
  conditionsChanged = false;
  cvValid = true;
  fontCanvasContext: CanvasRenderingContext2D;
  errorMsg = 'One or more enabled modules have no conditions';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal
  ) {
    this.conditionsForm = new UntypedFormGroup({
      paramsSetId: new UntypedFormControl(),
      checkAll: new UntypedFormControl(true),
      conditions: this.formBuilder.array([])
    });

    this.inputForm = this.formBuilder.group({
      conditionValue: new UntypedFormControl(null, Validators.pattern(/^-?[0-9]\d*(\.\d+)?$/)),
      numValue: new UntypedFormControl(null, Validators.pattern(/^-?[0-9]\d*(\.\d+)?$/)),
      alias: new UntypedFormControl(),
      materials: new UntypedFormControl()
    });

    this.templateForm = this.formBuilder.group({
      templateName: new UntypedFormControl()
    });

    this.fontCanvasContext = document.createElement('canvas').getContext('2d');
    if (this.fontCanvasContext) {
      this.fontCanvasContext.font = '400 14px "Open Sans", sans-serif';
    }

  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.wmrpMod && this.wmrpMod.length > 0) {
      this.conditionsForm = this.formBuilder.group({
        paramsSetId: new UntypedFormControl(),
        checkAll: new UntypedFormControl(true),
        conditions: this.createFormArray(this.wmrpMod)
      });
    }
    if (changes.panelHeight && changes.panelHeight.previousValue !== changes.panelHeight.currentValue) {
      if (this.editable) {
        this.conditionsHeight = this.panelHeight - 50 - 35 - 30; //50 for btn-containers, 35 for 'x', 30 for 'X modules enabled'
      } else {
        this.conditionsHeight = this.panelHeight - 90; // tabs at the top and btn at the bottom 
      }

    }
    if (changes.currentConditions && changes.currentConditions.previousValue !== changes.currentConditions.currentValue) {
      if (this.currentConditions?.length > 0) {

        this.conditionsForm.get('paramsSetId').setValue(this.currentConditions[0].wmrpAnalysisParamSet_Id); // temporary. todo: set updated ID when new templates are laoded
        // this.conditionsFA.get('')
        for (let i = 0; i < this.conditionsFA.length; i++) {
          const modId = this.conditionsFA.at(i).get('moduleId').value;
          this.currentConditions.forEach((c: any) => {
            if (modId === c.moduleId) {

              const conditions = this.conditionsFA.at(i).get('conds-input') as UntypedFormArray;

              // clear FormArray to avoid duplicates when savedTemplate is populated
              while (conditions.length !== 0) {
                conditions.removeAt(0)
              }
              const breakType = this.conditionsFA.at(i).get('breakType').value;
              this.conditionsFA.at(i).get('chkbox').setValue(c.enabled);
              c.conditions.forEach((condition: any, index: number) => {
                let fg;
                const conLen = c.conditions.length;
                if (breakType === 'number') {
                  let bv = condition.breakValue;
                  if (index === c.conditions.length - 1) {
                    // last item
                    if (condition.breakValue === 'max') {
                      bv = '> ' + c.conditions[index - 1].breakValue
                    }
                  }
                  fg = this.formBuilder.group({
                    'breakValue': new UntypedFormControl({ value: bv, disabled: false }),
                    'analysisValue': new UntypedFormControl({ value: condition.analysisValue, disabled: false }),
                    'alias': new UntypedFormControl({ value: condition.alias ? condition.alias : '', disabled: false }),
                  });
                } else {
                  // string
                  let materials: string[] = [];
                  let matArr;
                  if (typeof condition.breakValue === 'string') {
                    matArr = condition.breakValue.split(',');
                  } else {
                    matArr = condition.breakValue;
                  }
                  // if (this.editable) {

                  matArr.forEach((m: any) => {
                    const matVal = this.materials.filter((mat: any) => mat.code === m);
                    if (matVal.length > 0) {
                      materials.push(matVal[0].name);
                    } else {
                      materials.push(m);
                    }
                  })

                  fg = this.formBuilder.group({
                    'breakValue': new UntypedFormControl({ value: materials.join(', '), disabled: false }),
                    'analysisValue': new UntypedFormControl({ value: condition.analysisValue, disabled: false }),
                    'alias': new UntypedFormControl({ value: condition.alias ? condition.alias : '', disabled: false }),
                  });
                }

                conditions.push(fg);
              })

            }
          });
        }
        //  console.log(this.currentConditions);

        // disable values in materials drop down
        this.disableMaterials();
      }
    }
  }


  get conditionsFA() {
    return this.conditionsForm.get('conditions') as UntypedFormArray;
  }

  createFormArray(wmrpMod: WMRPModule[]): any {
    this.countEmitter.emit(wmrpMod.length);

    return new UntypedFormArray(
      wmrpMod.map(
        (item) =>
          new UntypedFormGroup({
            'chkbox': new UntypedFormControl(true),
            'moduleId': new UntypedFormControl(item.id),
            'breakType': new UntypedFormControl(ModuleBreakType[item.breakType]),
            'conds-input': this.formBuilder.array([])
          })

      )
    );
  }

  toggleAll() {
    const val = this.conditionsForm.get('checkAll').value;
    this.conditionsFA.controls.forEach(c => {
      (c as UntypedFormGroup).controls['chkbox'].setValue(val);
      if (val === true) {
        this.checkCount = this.conditionsFA.length;
      } else {
        this.checkCount = 0;
      }
    });
    this.countEmitter.emit(this.checkCount);
  }

  addInput(parameterIdx: number, currentVal?: UntypedFormGroup, conditionIdx?: number) {
    if (this.editable) {
      this.disableMaterials();
      if (conditionIdx !== null && conditionIdx !== undefined) this.currentConditionIndex = conditionIdx;
      this.currentParameterIndex = parameterIdx;
      this.breakType = this.conditionsFA.at(parameterIdx).get('breakType').value;

      if (currentVal) {
        this.inputForm.get('alias').setValue(currentVal.controls.alias.value);
        this.inputForm.get('numValue').setValue(currentVal.controls.analysisValue.value);
        // this.inputForm.get(this.breakType == 'string' ? 'materials' : 'conditionValue').setValue(currentVal.controls.breakValue.value);
        if (this.breakType == 'string') {
          const currentMaterialNames = currentVal.controls.breakValue.value.split(', ');
          let currentMaterialCodes: string[] = [];
          this.materials.forEach(mat => {
            if (currentMaterialNames.includes(mat.name)) {
              mat.disabled = false;
              currentMaterialCodes.push(mat.code)
            }
          })
          this.inputForm.get('materials').setValue(currentMaterialCodes);
        } else {
          this.inputForm.get('conditionValue').setValue(currentVal.controls.breakValue.value.toString().replace('> ', ''));
        }
        this.inputForm.markAllAsTouched();
      } else {
        // adding new condition, hide delete button
        this.currentConditionIndex = -1;
      }

      // disable formControl & validation
      if (this.breakType === 'string') {
        this.inputForm.get('conditionValue').disable();
        this.inputForm.get('materials').enable();
      } else {
        this.inputForm.get('conditionValue').enable();
        this.inputForm.get('materials').disable();
      }

      this.modal = this.modalService.open(this.condition, { backdrop: 'static' });
    }
  }

  deleteCondition(isEdit: boolean = null) {
    this.conditionsChanged = true;
    (this.conditionsFA.at(this.currentParameterIndex).get('conds-input') as UntypedFormArray).removeAt(this.currentConditionIndex);

    // reset parameter index for next saveCondition()
    this.currentConditionIndex = -1
    this.dismissModal();
    if (!isEdit && this.conditionsFA.at(this.currentParameterIndex).get('breakType').value === 'number') {
      const conditionsArray = this.conditionsFA.at(this.currentParameterIndex).get('conds-input') as UntypedFormArray;
      const arrLen = conditionsArray.getRawValue().length - 1;
      const lastItem = conditionsArray.getRawValue()[arrLen];

      // check if second to last breakValue changed
      const secondLast = conditionsArray.length >= 2 ? conditionsArray.at(conditionsArray.length - 2).get('breakValue').value : conditionsArray.at(conditionsArray.length - 1).get('breakValue').value;
      const lastItemBV = lastItem.breakValue.substr(1).trim();
      if (Number(secondLast) !== Number(lastItemBV)) {
        let bv = secondLast;
        if (bv.toString().indexOf('>') === -1) {
          bv = '> ' + secondLast;
        }

        conditionsArray.at(conditionsArray.length - 1).get('breakValue').setValue(bv);

      }
    }
    this.enableRun();
  }

  saveCondition() {
    const isValid = this.checkConditionValue(this.inputForm.value.conditionValue);
    // console.log(this.inputForm.value);
    if (isValid) {

      if (this.breakType === 'number') {
        const conditionsArray = this.conditionsFA.at(this.currentParameterIndex).get('conds-input') as UntypedFormArray;
        const originalLast = conditionsArray.at(conditionsArray.length - 1);
        const bv = this.currentConditionIndex === conditionsArray.length - 1 ? '> ' + this.inputForm.value.conditionValue : this.inputForm.value.conditionValue;
        conditionsArray.push(
          this.formBuilder.group({
            'breakValue': new UntypedFormControl({ value: bv, disabled: true }),
            'analysisValue': new UntypedFormControl({ value: this.inputForm.value.numValue, disabled: true }),
            'alias': new UntypedFormControl({ value: this.inputForm.value.alias, disabled: true })
          })
        )

        const currentItemIndex = this.currentConditionIndex;
        // if editing a condition, delete the old one
        if (this.currentConditionIndex > -1) this.deleteCondition(true);

        // exclude last condition and sort by breakValue
        const sortArray = conditionsArray.getRawValue().filter(c => c.breakValue.toString().indexOf('>') === -1);
        sortArray.sort((a: { breakValue: any; }, b: { breakValue: any; }) => {
          return a.breakValue - b.breakValue;
        });

        // check if last sortArray breakValue changed
        const sortLast = sortArray[sortArray.length - 1].breakValue;
        const lastItemBV = originalLast.get('breakValue').value.toString().substr(1).trim();
        let lastItem;

        if (Number(sortLast) !== Number(lastItemBV)) {
          lastItem = {
            breakValue: '> ' + sortLast,
            analysisValue: originalLast.get('analysisValue').value,
            alias: originalLast.get('alias').value
          };
        } else {
          // last item edited
          const lastIdx = conditionsArray.controls.length - 1;
          if (currentItemIndex === lastIdx) {
            lastItem = {
              breakValue: originalLast.get('breakValue').value,
              analysisValue: conditionsArray.at(lastIdx).get('analysisValue').value,
              alias: conditionsArray.at(lastIdx).get('alias').value
            }

          } else {
            // not last item edited, put original back
            lastItem = {
              breakValue: originalLast.get('breakValue').value,
              analysisValue: originalLast.get('analysisValue').value,
              alias: originalLast.get('alias').value
            }

          }
        }
        // add last condition back
        sortArray.push(lastItem);



        // console.log(sortArray);
        // set sorted array to FormArray
        this.conditionsFA.at(this.currentParameterIndex).get('conds-input').setValue(sortArray);
      } else { // string
        const matVals: string[] = [];
        this.inputForm.value.materials.forEach((v: string) => {
          const strVal = this.materials.filter((m, index) => {
            if (m.code === v) {
              matVals.push(m.name);
              // this.materials[index].disabled = true; // disable values in drop down
              const temp = Object.assign({}, this.materials[index], {
                disabled: true
              })
              this.materials = [
                ...this.materials.slice(0, index),
                temp,
                ...this.materials.slice(index + 1)
              ]
            }
          });

        });
        (this.conditionsFA.at(this.currentParameterIndex).get('conds-input') as UntypedFormArray).push(
          this.formBuilder.group({
            'breakValue': new UntypedFormControl({ value: matVals.join(', '), disabled: true }),
            'analysisValue': new UntypedFormControl({ value: this.inputForm.value.numValue, disabled: true }),
            'alias': new UntypedFormControl()
          })
        );
        // if editing a condition, delete the old one
        if (this.currentConditionIndex > -1) this.deleteCondition()
      }

      this.conditionsChanged = true;
      this.dismissModal();
      this.inputForm.reset();
    }
  }

  checkConditionValue(val: string) {
    let isValid = true;
    //  console.log((this.conditionsFA.at(this.currentParameterIndex).get('conds-input') as FormArray).controls);
    const ctrls = (this.conditionsFA.at(this.currentParameterIndex)?.get('conds-input') as UntypedFormArray)?.controls;
    ctrls.forEach((c: any, index: number) => {
      const condVal = c.get('breakValue').value;
      if (index !== this.currentConditionIndex && this.currentConditionIndex + 1 !== ctrls.length) {
        if (Number(condVal) === Number(val)) {
          isValid = false;
          this.cvValid = false;
          this.inputForm.get('conditionValue').setErrors({ duplicate: true });
        }
      }
    })

    if (isValid) {
      this.inputForm.updateValueAndValidity();
    }

    return isValid;
  }

  dismissModal() {
    if (this.breakType === 'string') {
      // re-enable all in materials list
      this.materials.forEach(m => {
        if (m.disabled) {
          m.disabled = false;
        } else {
          const temp = Object.assign({}, m, {
            disabled: false
          });
          m = temp;
        }
      });
    }
    if (this.modal) {
      this.modal.dismiss();
      this.inputForm.reset();
    }
  }

  hideCtrl(parentIndex: number, index: number, ctrlName: string) {
    const val = (this.conditionsFA.at(parentIndex).get('conds-input') as UntypedFormArray).at(index).get(ctrlName).value;
    if (val && val.length > 0) {
      return false;
    }
    return true;
  }

  calculateWidth(parentIndex: number, index: number, ctrlName: string) {
    const val = (this.conditionsFA.at(parentIndex).get('conds-input') as UntypedFormArray).at(index).get(ctrlName).value;

    if (this.isNumber(val) && ctrlName === 'analysisValue') {
      return 25;
    }

    const text = val ? val.toString() : '0'; // sometimes the 0 comes across as blank string
    if (this.fontCanvasContext) {
      const metrics = this.fontCanvasContext.measureText(text);
      const spacer = 6; // input padding + 2
      return metrics.width + spacer;
    }

  }

  isAliasBlank(parentIndex: number, index: number) {
    const val = (this.conditionsFA.at(parentIndex).get('conds-input') as UntypedFormArray).at(index).get('alias').value;
    if (val && val.length > 0) {
      return false;
    }
    return true;
  }

  isNumber(n: any) { return !isNaN(parseFloat(n)) && !isNaN(n - 0); }

  chkboxChange(i: number) {
    this.conditionsChanged = true;
    const chkVal = this.conditionsFA.at(i).get('chkbox').value

    if (chkVal === true) {
      this.checkCount++;
    } else {
      this.checkCount--;
    }
    this.countEmitter.emit(this.checkCount);
  }

  isLastCondition(parentIndex: number, index: number) {
    if (this.currentConditionIndex === -1) {
      // to hide delete button for new condition
      return true;
    }

    return (this.conditionsFA.at(parentIndex).get('conds-input') as UntypedFormArray).length === index + 1;
  }

  disableMaterials() {
    const idx = this.wmrpMod.findIndex(w => w.breakType === 0);
    if (idx > -1) {
      const matArray = (this.conditionsFA.at(idx).get('conds-input') as UntypedFormArray);
      for (let i = 0; i < matArray.length; i++) {
        const vals = matArray.at(i).get('breakValue').value.toString().split(',');
        for (let x = 0; x < vals.length; x++) {
          this.materials.filter((m, index) => {
            if (m.name === vals[x].trim()) {
              // this.materials[index].disabled = true; // disable values in drop down
              const temp = Object.assign({}, this.materials[index], {
                disabled: true
              })
              this.materials = [
                ...this.materials.slice(0, index),
                temp,
                ...this.materials.slice(index + 1)
              ]
            }
          });
        }
      }
    }

  }

  saveParamsToTemplate() {
    this.showTemplateForm = false;
    // const templateId = this.conditionsForm.get('paramsSetId').value;
    const templateName = this.templateForm.get('templateName').value;
    const moduleArr: WmrpSaveObject = {
      // WmrpParamSetId: templateId,
      wmrpIsTemplate: true,
      wmrpTemplateName: templateName,
      wmrpAnalysisParams: []
    };

    for (let i = 0; i < this.conditionsFA.length; i++) {
      const mod = this.conditionsFA.at(i);
      // console.log((mod.get('conds-input') as FormArray).getRawValue());

      // do look up to convert materials name back to code
      if (mod.get('breakType').value === 'string') {
        const matConditions = (mod.get('conds-input') as UntypedFormArray).getRawValue();
        const matCopy: string[] = [];
        matConditions.forEach(mc => {
          const tempArr = mc.breakValue.split(',');
          const newArr: string[] = [];
          tempArr.forEach((m: string) => {
            const matCode = this.materials.filter(mat => mat.name === m.trim())[0];
            if (matCode) {
              newArr.push(matCode.code);
            } else {
              newArr.push(m);
            }

          });
          const newMc = Object.assign({}, mc, {
            breakValue: newArr
          });
          matCopy.push(newMc);
        });

        //  console.log(matCopy);
        const temp = {
          wmrpIsTemplate: true,
          wmrpModule_Id: mod.get('moduleId').value,
          enabled: mod.get('chkbox').value,
          conditions: JSON.stringify(matCopy)
        };
        moduleArr.wmrpAnalysisParams.push(temp);
      } else {
        // breakType = number
        const temp = {
          wmrpIsTemplate: true,
          wmrpModule_Id: mod.get('moduleId').value,
          enabled: mod.get('chkbox').value,
          conditions: this.createConditionJson(mod.get('conds-input') as UntypedFormArray)
        };
        moduleArr.wmrpAnalysisParams.push(temp);
      }

    }
    // console.log(moduleArr);
    this.paramsSaveEmitter.emit(moduleArr);
    this.templateForm.reset();
  }

  createConditionJson(fa: UntypedFormArray) {
    const conditionsArr = [];
    for (let i = 0; i < fa.length; i++) {
      const condGroup = fa.at(i);
      const temp = {
        breakValue: condGroup.get('breakValue').value,
        analysisValue: condGroup.get('analysisValue').value,
        alias: condGroup.get('alias').value
      };
      conditionsArr.push(temp);
    }
    return JSON.stringify(conditionsArr);
  }

  runAnalysis() {
    if (this.conditionsChanged) {

      const conditionsValue = this.conditionsForm.getRawValue();
      // Convert materials to domain codes
      const changedParams: WmrpAnalysisParam[] = conditionsValue.conditions.map(
        (item: any) => {
          if (item.breakType === 'string') {
            const newArr: any[] = [];
            item['conds-input'].forEach((cond: any) => {

              const matArr = cond.breakValue.split(',');
              const conditions: string[] = [];
              matArr.forEach((m: string) => {
                const matCode = this.materials.filter(mat => mat.name === m.trim())[0];
                if (matCode) {
                  conditions.push(matCode.code);
                } else {
                  conditions.push(m);
                }
              });
              const newCond = Object.assign({}, cond, {
                breakValue: conditions
              })
              newArr.push(newCond);

            });
            return {
              wmrpModule_Id: item.moduleId,
              enabled: item.chkbox,
              conditions: newArr
            }
          } else {
            return {
              wmrpModule_Id: item.moduleId,
              enabled: item.chkbox,
              conditions: item['conds-input']
            }
          }
        }
      );

      this.runAnalysisCustomEmitter.emit(changedParams);
    } else {
      this.runAnalysisTemplateEmitter.emit(this.conditionsForm.get('paramsSetId').value);
    }

  }

  getEditable() {
    return !this.editable ? true : null;
  }

  canDelete(paramIndex: number, condIndex: number) {
    let result = true;
    //string
    if (this.wmrpMod[paramIndex].breakType === 0) {
      result = true;
    } else if (this.wmrpMod[paramIndex].breakType === 1) {
      // number
      if ((this.conditionsFA.at(paramIndex).get('conds-input') as UntypedFormArray).length === condIndex + 1) {
        // last
        result = false;
      }
    }

    // add new condition
    if (condIndex === -1) {
      result = false;
    }

    return result;
  }

  enableRun() {
    let result = true;
    const materialModId = this.wmrpMod.find(m => m.title.toLowerCase() === 'main material');
    const materialsList = Object.assign([], this.materials);
    for (const c of this.conditionsFA.controls) {
      if (c.get('breakType').value === 'string') {
        // string
        if (c.get('chkbox').value === true && (c.get('conds-input') as UntypedFormArray).length === 0) {
          result = false;
          this.errorMsg = 'One or more enabled modules have no conditions';
          break;
        }
      } else {
        // number
        if (c.get('chkbox').value === true && (c.get('conds-input') as UntypedFormArray).length === 1) {
          result = false;
          this.errorMsg = 'One or more enabled modules have no conditions';
          break;
        }
      }

      // check if all materials included if all modules populated
      if (result === true) {
        if (c.get('moduleId')?.value === materialModId?.id && c.get('chkbox').value === true) {
          for (const ctrl of (c.get('conds-input') as any).controls) {
            const bv = ctrl.get('breakValue').value.toString().split(',');
            for (const val of bv) {
              const idx = materialsList.findIndex(m => m.name === val.trim());
              if (idx > -1) {
                materialsList.splice(idx, 1);
              }
            }
          }
          // console.log(materialsList);
          if (materialsList.length > 0) {
            result = false;
            this.errorMsg = 'Not all materials have been assigned a value';
          }
        }

      }

    }
    return result;
  }

  getCondsCount(i: number) {
    if ((this.conditionsFA.at(i).get('conds-input') as UntypedFormArray)?.controls.length) {
      const condsCount = (this.conditionsFA.at(i).get('conds-input') as UntypedFormArray).controls.length;
      if (condsCount >= 10) {
        return true;
      }
    }
    return null;
  }

  exportParams(): void {
    this.exportEmitter.emit();
  }

}
